var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgAdAutosFeedbackSuccess = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("rect", {
    width: 52.979,
    height: 70.491,
    x: 21.75,
    y: 13.75,
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeWidth: 1.5,
    rx: 3.25
  }), React.createElement("rect", {
    width: 7.783,
    height: 1.5,
    x: 56.995,
    y: 63.782,
    fill: borderColor,
    rx: 0.75
  }), React.createElement("rect", {
    width: 8.269,
    height: 1.5,
    x: 29.756,
    y: 57.459,
    fill: borderColor,
    rx: 0.75
  }), React.createElement("rect", {
    width: 23.348,
    height: 1.5,
    x: 29.756,
    y: 51.135,
    fill: borderColor,
    rx: 0.75
  }), React.createElement("rect", {
    width: 7.783,
    height: 1.5,
    x: 56.995,
    y: 51.135,
    fill: borderColor,
    rx: 0.75
  }), React.createElement("rect", {
    width: 23.348,
    height: 1.5,
    x: 41.43,
    y: 57.459,
    fill: borderColor,
    rx: 0.75
  }), React.createElement("rect", {
    width: 23.348,
    height: 1.5,
    x: 29.756,
    y: 63.782,
    fill: borderColor,
    rx: 0.75
  }), React.createElement("path", {
    fill: color,
    d: "M29.756 74.078a3 3 0 0 1 3-3h13.457a3 3 0 0 1 0 6H32.755a3 3 0 0 1-3-3Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-90)",
    d: "M38.757 41.53v2.005a1.29 1.29 0 0 1-1.245 1.358h-3.606a1.29 1.29 0 0 1-1.245-1.358v-2.257l6.096.251Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M66.106 27.873c0-1.335-1.262-1.687-2.258-1.558a5.523 5.523 0 0 0-1.613.465l-1.097.48c-.764-1.638-2.2-4.073-3.338-4.883C56.771 21.648 53.82 21 48.085 21c-5.734 0-8.689.648-9.718 1.377-1.122.787-2.535 3.187-3.309 4.822l-1.054-.397a5.446 5.446 0 0 0-1.665-.487c-1.013-.129-2.258.223-2.258 1.558-.016 2.668 3.487 1.742 3.487 1.742-.935.99-3.503 4.035-3.503 6.257 0 5.335 3.11 5.615 4.819 5.615h26.4c1.709 0 4.838-.28 4.838-5.615 0-2.222-2.58-5.267-3.506-6.273-.017.016 3.49.942 3.49-1.726Zm-18.02 1.89c-6.022 0-11.66-.287-11.66-.287.864-2.325 2.68-4.596 3.225-5.07 0 0 1.532-1.184 8.431-1.184 6.9 0 8.415 1.171 8.428 1.184.552.477 2.367 2.745 3.225 5.07.01 0-4.338.287-11.65.287Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-90)",
    d: "M63.505 41.265v2.258a1.29 1.29 0 0 1-1.242 1.357h-3.61a1.292 1.292 0 0 1-1.24-1.357v-2.036l6.092-.222Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M32.6 41.371v2.258A1.29 1.29 0 0 0 33.852 45h3.599a1.29 1.29 0 0 0 1.239-1.358v-1.77"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M33.938 26.909a5.328 5.328 0 0 0-1.664-.487c-1.01-.132-2.258.222-2.258 1.555 0 2.667 3.506 1.728 3.506 1.728C32.561 30.708 30 33.756 30 35.98c0 5.331 3.112 5.615 4.838 5.615h26.4c1.709 0 4.838-.284 4.838-5.615 0-2.223-2.58-5.27-3.506-6.274 0 0 3.506.939 3.506-1.728 0-1.333-1.265-1.687-2.277-1.555a5.308 5.308 0 0 0-1.613.464"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M61.077 27.357c-.778-1.613-2.203-4.064-3.342-4.873-1.025-.73-3.98-1.38-9.715-1.38-5.734 0-8.685.644-9.711 1.38-1.126.796-2.542 3.183-3.313 4.818"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M59.682 29.58c-.864-2.323-2.683-4.593-3.225-5.07 0 0-1.526-1.184-8.428-1.184-6.902 0-8.424 1.174-8.437 1.187-.552.474-2.364 2.744-3.226 5.067 0 0 5.642.287 11.66.287 7.309 0 11.656-.287 11.656-.287ZM63.444 41.371v2.258a1.306 1.306 0 0 1-1.245 1.358h-3.606a1.306 1.306 0 0 1-1.245-1.358v-2.035M52.465 41.594v-1.7a.803.803 0 0 0-.803-.806h-7.28a.806.806 0 0 0-.806.806v1.7M51.217 36.865h-6.39M52.548 34.804H43.49"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M38.48 34.814H34.24c-.586 0-1.06.475-1.06 1.061v1.413c0 .586.474 1.061 1.06 1.061h4.238c.586 0 1.062-.475 1.062-1.061v-1.413c0-.586-.476-1.06-1.062-1.06ZM61.802 34.814h-4.238c-.586 0-1.06.475-1.06 1.061v1.413c0 .586.474 1.061 1.06 1.061h4.238c.586 0 1.062-.475 1.062-1.061v-1.413c0-.586-.476-1.06-1.062-1.06Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m36.422 30.486 2.096 2.096M39.163 33.227l.324.324M59.806 30.486l-2.097 2.096M57.065 33.227l-.324.324"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M34.173 36.066h1.936M57.396 36.066h1.935"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M70.5 90C78.508 90 85 83.508 85 75.5S78.508 61 70.5 61 56 67.492 56 75.5 62.492 90 70.5 90Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    fillRule: "evenodd",
    stroke: "var(--color-neutral-70)",
    strokeWidth: 1.5,
    d: "M65.985 75.471a.449.449 0 0 0-.636 0 .452.452 0 0 0 0 .638l3 3.008a.45.45 0 0 0 .636 0l6.6-6.618a.452.452 0 0 0 0-.638.45.45 0 0 0-.636 0l-6.282 6.3-2.682-2.69Z",
    clipRule: "evenodd"
  }));
};
export default SvgAdAutosFeedbackSuccess;